<template>
    <div class="what-is-bld">
        <hero-section :hero-data="heroData" />
        <bld-features :bld-features-data="bldFeaturesData" />
        <customer-service :customer-service-data="customerServiceData" />
        <bld-reviews :reviews-data="bldReviewsData" :review-score="reviewScore" />
        <build-it-yourself :build-it-data="buildItData" />
        <video-section :video-data="videoSectionData" />
    </div>
</template>

<script>
import HeroSection from "./hero-section";
import BldFeatures from "./bld-features";
import CustomerService from "./customer-service";
import BldReviews from "./bld-reviews";
import BuildItYourself from "./build-it-yourself";
import VideoSection from "./video-section";

export default {
    name: "WhatIsBLD",
    components: {
        HeroSection,
        BldFeatures,
        CustomerService,
        BldReviews,
        BuildItYourself,
        VideoSection
    },
    data() {
        return {
            heroData: {},
            bldFeaturesData: [],
            customerServiceData: {},
            bldReviewsData: [],
            reviewScore: {
                averageRating: null,
                count: null
            },
            buildItData: [],
            videoSectionData: {},
        }
    },
    created() {
        axios({
            url: "public-landing-pages/what-is-bld"
        }).then(({ data }) => {
            this.heroData = data.landing_page_sections[0];
            this.bldFeaturesData = data.landing_page_sections.slice(1, 5);
            this.customerServiceData = data.landing_page_sections[5];
            this.bldReviewsData = data.landing_page_sections.slice(6, 9);
            this.buildItData = data.landing_page_sections.slice(9, 15);
            this.videoSectionData = data.landing_page_sections[15];
        })

        axios({
            url: "public-reviews?sort=created_at|desc&page=1&format=true&limit=1"
        }).then(({ data }) => {
            this.reviewScore.averageRating = data.average_rating;
            this.reviewScore.count = data.total_items;
        })
    }
}
</script>